<ng-container *transloco="let t; read: 'org-settings-event-request-config'">
  <p-messages severity="info">
    <ng-template pTemplate>
      <div class="ml-2">{{ t('description') }}</div>
    </ng-template>
  </p-messages>
</ng-container>
<app-event-request-config-table></app-event-request-config-table>
